import type {PageRouteConfig} from '@router';

import ProDetails from 'modules/Services/PromotionCenter/Pro/Details/ProDetails';

export function createPromotionCenterProDetailsRoute(): PageRouteConfig {
  return {
    element: <ProDetails />,
    layout: {
      title: 'جزئیات فعال‌سازی پرو',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: -1,
      headerDataKey: 'proDetails'
    },
    initialHeaderData: {
      proDetails: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
